import {PlacePresentationValueObject} from "../../../../model/vo/content/place/PlacePresentationValueObject";
import {PlaceEventType} from "../../../../constant/EventType";
import {DataTransferObjectValidation} from "../../../../type/Types";
import {CampaignCodeValues} from "../../../../constant/mediaCode";
import failuerImg from "../../../../assets/ver3/nbt/failure.png";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useQuery} from "../../../../hooks/useQuery";
import {
    useCurrentPageUpdate,
    useGuideExpirationDate,
    useNextPageUpdate,
    useSetIsFinish
} from "../../../../stores/useStore";
import {StatePair, useStatePair} from "../../../../type/States";
import {FieldProps, mergeClasses} from "@fluentui/react-components";
import {
    PlaceParticipationDataTransferObject
} from "../../../../model/dto/content/place/PlaceParticipationDataTransferObject";
import {PlaceParticipationIO} from "../../../../io/content/place/PlaceParticipationIO";
import {getFormattedDate} from "../../../../utils/formatDate";
import AlertDialog from "../../pink_ver1/common/AlertDialog";
import {Column, Row} from "../../../../ui/mission/common/Layout";
import {pinkTheme} from "../../../../styles/mission/theme";
import {useStyles} from "../../../../styles/mission/ver1";
import {PlacePathTypeColor, PlacePathTypeString, resolvePlacePathType} from "../../../../constant/PlaceMissionType";
import {PlacePathJointEventIO} from "../../../../io/content/place/PlacePathJointEventIO";

export default function AnswerInput({
                                        placePathJointId,
                                        userId,
                                        mediaId,
                                        mediaCode,
                                        onClickPreviousBtn,
                                        data,
                                    }: {
    placePathJointId: bigint
    userId: bigint
    mediaId: string
    mediaCode: string
    onClickPreviousBtn: () => void
    data: PlacePresentationValueObject
}) {
    const [answer, setAnswer] = useState('')
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
    const [dialogMsg, setDialogMsg] = useState<string>('정답 제출 중 입니다...')
    const [dialogTitle, setDialogTitle] = useState<string>('로딩중')
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate();
    const [img, setImg] = useState<string | null>(null)
    const [isFocused, setIsFocused] = useState<boolean>(false);

    const query = useQuery()

    const setIsFinish = useSetIsFinish()

    const hideGuide = useGuideExpirationDate()

    const updateCurrentPage = useCurrentPageUpdate()
    const updateNextPage = useNextPageUpdate()

    const basicStyles = useStyles()

    const inputValidationStates: Record<keyof PlaceParticipationDataTransferObject.Post, StatePair<FieldProps['validationState']>> = {
        placePathJointId: useStatePair<FieldProps['validationState']>('none'),
        userId: useStatePair<FieldProps['validationState']>('none'),
        mediaId: useStatePair<FieldProps['validationState']>('none'),
        mediaCode: useStatePair<FieldProps['validationState']>('none'),
        campaignCode: useStatePair<FieldProps['validationState']>('none'),
        answer: useStatePair<FieldProps['validationState']>('none'),
        placeAttractionId: useStatePair<FieldProps['validationState']>('none'),
    }

    const openDialog = (title: string, content: string, src: string | null) => {
        try {
            setDialogTitle(title)
            setDialogMsg(content)
            setImg(src)
        } finally {
            setIsDialogOpen(true)
        }
    }

    const closeDialog = () => setIsDialogOpen(false)

    const submitAnswer = async (answer: string) => {

        inputValidationStates.answer.setValue('none')

        try {

            if (placePathJointId && userId && mediaId) {
                PlacePathJointEventIO.post({
                    placePathJointId: placePathJointId,
                    userId: userId,
                    misc: mediaId,
                    eventType: PlaceEventType.PlaceAnswerSubmitClick
                })
                .then(v => console.log(v))
                .catch(e => console.error(e))
            }

            const dto : PlaceParticipationDataTransferObject.Post = {
                placePathJointId: data.placePathJointId,
                userId: userId,
                mediaId: mediaId,
                mediaCode: mediaCode,
                answer: DataTransferObjectValidation.validate(PlaceParticipationDataTransferObject.Post.validation, 'answer', answer, () => inputValidationStates.answer.setValue('error')),
                placeAttractionId: data.placeAttractionId ? data.placeAttractionId : null,
                campaignCode: query.get("campaignCode") as CampaignCodeValues
            }

            PlaceParticipationIO.post(dto)
                .then((res: any) => {

                    if (!res) {
                        navigate('/error')
                        setCurrentPage()
                        return
                    }

                    if (res.isExhausted && mediaCode == 'NbtAdison') {
                        openDialog(
                            '정답 제출 실패',
                            `미션 참여 중 수량이 모두 소진되었습니다.\n선착순 특성상 빠르게 마감될 수 있는 점\n양해 부탁드립니다.\n현재 광고 확보에 다소 어려움이 있어\n넉넉한 수량을 준비하지 못한 점 죄송합니다.\n더 많은 광고를 유치하여 안정적인 참여 환경을\n만들도록 하겠습니다.`,
                            failuerImg
                        )
                    } else if (res.isPassed && res.isPostBackSuccess) {
                        navigate('/success')
                        setIsFinish(true)
                        setCurrentPage()
                    } else if (res.isPassed && !res.isPostBackSuccess) {
                        navigate('/failure')
                        setIsFinish(true)
                        setCurrentPage()
                    } else {
                        openDialog('오답', '정답이 틀렸습니다.', failuerImg)
                        setTimeout(() => {
                            closeDialog()
                        }, 3000)
                    }
                })
                .catch((e) => {
                    console.error(e)
                    openDialog('오답', '정답 제출 중에 오류가 발생했습니다.', failuerImg)
                })

        } catch (error) {
            console.error(error)
            openDialog('오류', '정답 제출 중에 오류가 발생했습니다.', failuerImg)
            navigate('/error')
        }
    }

    const setCurrentPage = () => {
        if (!hideGuide || getFormattedDate(new Date(hideGuide)).getTime() < getFormattedDate(new Date()).getTime()) {
            updateCurrentPage('GuideLine');
            updateNextPage('Mission');
        } else {
            updateCurrentPage('Mission');
            updateNextPage('Mission');
        }
    }

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!answer) {
            alert('정답을 입력해주세요')
            return
        }
        setIsLoading(true)
        try {
            openDialog('로딩중', '정답 제출 중 입니다.....', null)
            await submitAnswer(answer)
        } finally {
            setIsLoading(false)
        }
    }

    return <div style={{backgroundColor: 'white'}}>
        <AlertDialog
            title={dialogTitle}
            description={dialogMsg}
            isOpen={isDialogOpen}
            onClose={closeDialog}
            src={img}
            primaryColor={resolvePlacePathType(data.pathType,PlacePathTypeColor)}
        />
            <form onSubmit={onSubmit}
                  style={{backgroundColor: 'transparent', padding: '16px', display: 'flex', flexDirection:'column', gap: '12px'}}>
                    <input
                        placeholder={resolvePlacePathType(data.pathType,PlacePathTypeString)}
                        value={answer}
                        style={{
                            borderRadius: '16px',
                            padding: '10px',
                            border: isFocused ? `1px solid white` : `1px solid ${pinkTheme.outliendBtn}`,
                            outline: isFocused ? `2px solid ${resolvePlacePathType(data.pathType,PlacePathTypeColor)}` : `none`,
                            height: '22px',
                            fontFamily:'GangwonEduPowerExtraBoldA'
                        }}
                        onChange={(e) => setAnswer(e.target.value)}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        required
                    />
                <Row gap={'8px'}>
                    <button
                        className={mergeClasses(basicStyles.roundedBtn)}
                        style={{
                            flex: 1,
                            backgroundColor: 'white',
                            border: `none`,
                            color: resolvePlacePathType(data.pathType,PlacePathTypeColor),
                            fontFamily:'GangwonEduPowerExtraBoldA',
                            boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.25)',
                        }}
                        disabled={isLoading}
                        onClick={()=>onClickPreviousBtn()}
                    >
                        이전
                    </button>
                    <button
                        type="submit"
                        className={mergeClasses(basicStyles.roundedBtn, basicStyles.primaryBtn)}
                        style={{
                            flex: 3,
                            backgroundColor: resolvePlacePathType(data.pathType, PlacePathTypeColor),
                            border: `2px solid ${resolvePlacePathType(data.pathType,PlacePathTypeColor)}`,
                            fontFamily:'GangwonEduPowerExtraBoldA',
                            boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
                        }}
                        disabled={isLoading}
                    >
                        제출하기
                    </button>
                </Row>
            </form>
        </div>
}